import React from 'react';
import { createUseStyles } from 'react-jss';

interface StyleProps {
  color?: string;
}

const DEFAULT_STRIPE_COLOR = '#D9D9D9';
const DEFAULT_STRIPE_COLOR_DARK = '#4a4a4a';
const LINE_HEIGHT = '23px';

const useStyles = createUseStyles({
  stripe: {
    marginLeft: '5px',
    marginRight: '10px',
    width: '4px',
    height: LINE_HEIGHT,
    borderRadius: '2px',
    backgroundColor: (props: StyleProps) => props.color || DEFAULT_STRIPE_COLOR,
    transition: 'background-color 0.3s ease',

    // Dark mode styles
    '@media (prefers-color-scheme: dark)': {
      backgroundColor: (props: StyleProps) => props.color || DEFAULT_STRIPE_COLOR_DARK,
    },
  },
  titleContainer: {
    height: LINE_HEIGHT,
    display: 'flex',
    alignItems: 'center',
  },
  title: {
    margin: 0,
    fontSize: '16px',
    fontWeight: 600,
    color: '#282828',
    transition: 'color 0.3s ease',

    // Dark mode styles
    '@media (prefers-color-scheme: dark)': {
      color: '#ffffff',
    },
  },
  subtitle: {
    margin: 0,
    fontSize: '15px',
    fontWeight: 400,
    color: '#666666',
    transition: 'color 0.3s ease',

    // Dark mode styles
    '@media (prefers-color-scheme: dark)': {
      color: '#b3b3b3',
    },
  },
});

interface ListHeaderProps {
  title: string;
  subtitle: string;
  color?: string;
}

const ListHeader: React.FC<ListHeaderProps> = ({ title, subtitle, color }) => {
  const classes = useStyles({ color });

  return (
    <div style={{ display: 'flex' }}>
      <div className={classes.stripe} />
      <div>
        <div className={classes.titleContainer}>
          <h2 className={classes.title}>{title}</h2>
        </div>
        <p className={classes.subtitle}>{subtitle}</p>
      </div>
    </div>
  );
};

export default ListHeader;
